function useQueryParams(query) {
  if (typeof window === 'undefined') {
    return null;
  }
  var search = window.location.search;
  var params = new URLSearchParams(search);
  return params.get(query);
}
export default useQueryParams;